import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Doctrine 01"
      title="Terms of Service"
      updated="February 2026"
      testid="page-terms"
    >
      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">1. Acceptance</h2>
        <p>
          By accessing The Secret Soulciety Club ("we", "us", "the Club") at secretsoulcietyclub.com,
          purchasing a membership, redeeming an access code, or attending any event, you agree to be bound
          by these Terms of Service. If you do not agree, you may not use the platform or attend our events.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">2. Age Requirement</h2>
        <p>
          You must be at least <strong className="text-cyan-400">19 years of age</strong> (or the legal age
          of majority in your jurisdiction, whichever is higher) to purchase memberships, redeem access codes,
          or attend Club events. Valid government-issued photo identification is required at every event.
          Entry will be refused without proper ID matching the name on the guest list.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">3. Membership</h2>
        <p>
          The Inner Circle membership is a recurring subscription billed at <strong>$10 USD per month</strong>
          via Stripe. Membership renews automatically until cancelled by you. You may cancel at any time from
          your member dashboard; cancellation takes effect at the end of the current billing period, and no
          partial refunds are issued for the unused portion of a paid month.
        </p>
        <p>
          Members receive a 15% discount on event tickets, priority queue placement, early ticket access,
          and eligibility for member-only drops. Benefits are non-transferable.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">4. Access Codes & Guest List</h2>
        <p>
          Access codes distributed via Instagram or other channels are single-use, event-specific, and may
          expire without notice. Redemption of an access code does not guarantee entry; final approval is
          subject to guest list review, capacity, and the sole discretion of the Club.
        </p>
        <p>
          All non-influencer attendees must submit a truthful Guest List Application. Providing false
          information is grounds for immediate revocation of access and forfeiture of ticket price.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">5. Tickets & Entry</h2>
        <p>
          Tickets are personal, non-transferable, and non-resellable. Any ticket found on a resale platform
          will be voided without refund. The digital entry pass (QR code) sent to your email is required
          for entry alongside valid government ID matching the guest name.
        </p>
        <p>
          The Club reserves the right to refuse entry for any reason, including but not limited to
          intoxication, disruptive behaviour, dress code violation, or ID mismatch.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">6. Influencer Program</h2>
        <p>
          Influencer status is granted at the sole discretion of the Club and may be revoked at any time.
          Complimentary entry and merch drops are conditional on continued good standing, promotion of
          approved events, and adherence to the confidentiality expectations of the Club.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">7. Conduct & Confidentiality</h2>
        <p>
          Members and guests agree to respect the privacy of other attendees. Unauthorized photography,
          video, or public disclosure of event locations, guest identities, or private moments inside a
          Club event may result in permanent ban and legal action.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">8. Cancellations, Postponements & Force Majeure</h2>
        <p>
          If an event is cancelled by the Club, ticket holders will be refunded in full to the original
          payment method within 10 business days. If an event is postponed or relocated, tickets remain
          valid for the rescheduled event; refunds are available upon written request within 7 days of the
          change notice. The Club is not liable for delays or cancellations caused by circumstances outside
          our reasonable control (weather, public health orders, venue failure, etc.).
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">9. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, the Club, its owners, employees, and affiliates shall not
          be liable for any indirect, incidental, or consequential damages arising from your use of the
          platform or attendance at an event. Total aggregate liability shall not exceed the amount you
          paid to the Club in the preceding 12 months.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">10. Modifications</h2>
        <p>
          We may update these Terms at any time. Continued use of the platform after changes are posted
          constitutes acceptance of the revised Terms.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">11. Contact</h2>
        <p>
          Questions? Reach us at{" "}
          <a href="mailto:secretsoulciety@secretsoulcietyclub.com" className="text-cyan-400 hover:text-white transition">
            secretsoulciety@secretsoulcietyclub.com
          </a>.
        </p>
      </section>
    </LegalLayout>
  );
}
